!(function(a, b) {
  'use strict';
  angular.module('ec.angulr', [
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngStorage',
    'ui.router',
    'ui.bootstrap',
    'ui.utils',
    'ui.load',
    'ui.jq',
    'oc.lazyLoad',
    'pascalprecht.translate',
  ]);
  var c = angular
    .module('ec.angulr')
    .config([
      '$controllerProvider',
      '$compileProvider',
      '$filterProvider',
      '$provide',
      function(a, b, d, e) {
        c.controller = a.register;
        c.directive = b.directive;
        c.filter = d.register;
        c.factory = e.factory;
        c.service = e.service;
        c.constant = e.constant;
        c.value = e.value;
      },
    ])
    .config([
      '$sceDelegateProvider',
      '$translateProvider',
      function(b, c) {
        var d = a.document.body,
          e = d.dataset,
          f = (e && e['app-cdn']) || d.getAttribute('data-app-cdn') || '/';
        b.resourceUrlWhitelist(['self', f + '**', 'https://d6zktcp1soofu.cloudfront.net/**']);
        c.determinePreferredLanguage(function() {
          return (e && e.lang) || d.getAttribute('data-lang') || 'en';
        });
        c.useSanitizeValueStrategy('sanitizeParameters');
        c.useLocalStorage();
      },
    ]);
  angular.module('ec.angulr').config([
    '$ocLazyLoadProvider',
    function(a) {
      a.config({
        debug: !1,
        events: !1,
        modules: [
          { name: 'smart-table', files: ['../vendor/angular-smart-table/dist/smart-table.min.js'] },
          { name: 'ngTagsInput', files: ['../vendor/ng-tags-input/ng-tags-input.min.js', '../vendor/ng-tags-input/ng-tags-input.min.css'] },
          { name: 'ngInfiniteScroll', files: ['../vendor/ngInfiniteScroll/build/ng-infinite-scroll.min.js'] },
          { name: 'angularFileUpload', files: ['../vendor/angular-file-upload/dist/angular-file-upload.min.js'] },
          {
            name: 'zeroclipboard',
            files: ['../vendor/zeroclipboard/dist/ZeroClipboard.min.js', '../vendor/clipboard/dist/clipboard.min.js'],
          },
        ],
      });
    },
  ]);
  !(function(a, b) {
    a.module('ec.angulr')
      .constant('I18N', { LANGS: { en: 'English' } })
      .constant('TRANSLATIONS', !1)
      .constant('TEMPLATE', {
        name: 'Quandoo',
        version: '0.1.0',
        color: {
          primary: '#7266ba',
          info: '#23b7e5',
          success: '#27c24c',
          warning: '#fad733',
          danger: '#f05050',
          light: '#e8eff0',
          dark: '#3a3f51',
          black: '#1c2b36',
        },
        settings: {
          themeID: 1,
          navbarHeaderColor: 'bg-black',
          navbarCollapseColor: 'bg-white-only',
          asideColor: 'bg-black',
          headerFixed: !0,
          asideFixed: !1,
          asideFolded: !1,
          asideDock: !1,
          container: !1,
        },
      });
  })(angular);
  angular.module('ec.angulr').controller('SetupController', [
    '$scope',
    '$translate',
    '$localStorage',
    '$window',
    'I18N',
    'TEMPLATE',
    function(a, b, c, d, e, f) {
      function g(a) {
        var b = a.navigator.userAgent || a.navigator.vendor || a.opera;
        return /iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/.test(b);
      }
      var h = !!navigator.userAgent.match(/MSIE/i);
      h && angular.element(d.document.body).addClass('ie');
      g(d) && angular.element(d.document.body).addClass('smart');
      a.app = f;
      angular.isDefined(c.settings) ? (a.app.settings = c.settings) : (c.settings = a.app.settings);
      a.$watch(
        'app.settings',
        function() {
          a.app.settings.asideDock && a.app.settings.asideFixed && (a.app.settings.headerFixed = !0);
          c.settings = a.app.settings;
        },
        !0,
      );
      a.lang = { isopen: !1 };
      a.langs = e.LANGS;
      a.selectLang = a.langs[b.storage().get(b.storageKey())] || a.langs[b.proposedLanguage()] || 'English';
      a.setLang = function(c) {
        a.selectLang = a.langs[c];
        a.selectedLanguageKey = c;
        b.use(c);
        a.lang.isopen = !a.lang.isopen;
      };
    },
  ]);
  angular.module('ec.angulr').directive('setNgAnimate', [
    '$animate',
    function(a) {
      return {
        link: function(b, c, d) {
          b.$watch(
            function() {
              return b.$eval(d.setNgAnimate, b);
            },
            function(b, d) {
              a.enabled(!!b, c);
            },
          );
        },
      };
    },
  ]);
  angular.module('ec.angulr').directive('uiButterbar', [
    '$rootScope',
    '$anchorScroll',
    function(a, b) {
      return {
        restrict: 'AC',
        template: '<span class="bar"></span>',
        link: function(a, c) {
          function d(a) {
            a && b();
            c.removeClass('hide').addClass('active');
          }
          function e(a) {
            a
              ? a.targetScope.$watch('$viewContentLoaded', function() {
                  f || c.addClass('hide').removeClass('active');
                })
              : c.addClass('hide').removeClass('active');
          }
          var f = !1;
          c.addClass('butterbar hide');
          a.$on('$stateChangeStart', function() {
            f = !1;
            d(!0);
          });
          a.$on('$stateChangeSuccess', function(a) {
            e(a);
          });
          a.$on('ui-butterbar.show', function() {
            f = !0;
            d();
          });
          a.$on('ui-butterbar.hide', function() {
            f = !1;
            e();
          });
        },
      };
    },
  ]);
  angular
    .module('ui.jq', ['ui.load'])
    .value('uiJqConfig', {})
    .directive('uiJq', [
      'uiJqConfig',
      'JQ_CONFIG',
      'uiLoad',
      '$timeout',
      function(a, b, c, d) {
        return {
          restrict: 'A',
          compile: function(e, f) {
            if (!angular.isFunction(e[f.uiJq]) && !b[f.uiJq]) throw new Error('ui-jq: The "' + f.uiJq + '" function does not exist');
            var g = a && a[f.uiJq];
            return function(a, e, f) {
              function h() {
                var b = [];
                if (f.uiOptions) {
                  b = a.$eval('[' + f.uiOptions + ']');
                  angular.isObject(g) && angular.isObject(b[0]) && (b[0] = angular.extend({}, g, b[0]));
                } else g && (b = [g]);
                return b;
              }
              function i() {
                d(
                  function() {
                    e[f.uiJq].apply(e, h());
                  },
                  0,
                  !1,
                );
              }
              function j() {
                f.uiRefresh &&
                  a.$watch(f.uiRefresh, function() {
                    i();
                  });
              }
              f.ngModel &&
                e.is('select,input,textarea') &&
                e.bind('change', function() {
                  e.trigger('input');
                });
              if (b[f.uiJq])
                c.load(b[f.uiJq])
                  .then(function() {
                    i();
                    j();
                  })
                  ['catch'](function() {});
              else {
                i();
                j();
              }
            };
          },
        };
      },
    ]);
  angular.module('ec.angulr').directive('uiNav', [
    '$timeout',
    function(b) {
      return {
        restrict: 'AC',
        link: function(b, c, d) {
          var e,
            f = $(a),
            g = 768,
            h = $('.app-aside'),
            i = '.dropdown-backdrop';
          c.on('click', 'a', function(a) {
            e && e.trigger('mouseleave.nav');
            var b = $(this);
            b.parent()
              .siblings('.active')
              .toggleClass('active');
            b.next().is('ul') && b.parent().toggleClass('active') && a.preventDefault();
            b.next().is('ul') || (f.width() < g && $('.app-aside').removeClass('show off-screen'));
          });
          c.on('mouseenter', 'a', function(b) {
            e && e.trigger('mouseleave.nav');
            $('> .nav', h).remove();
            if (!(!$('.app-aside-fixed.app-aside-folded').length || f.width() < g || $('.app-aside-dock').length)) {
              var c,
                d = $(b.target),
                j = $(a).height(),
                k = 50,
                l = 150;
              !d.is('a') && (d = d.closest('a'));
              if (d.next().is('ul')) {
                e = d.next();
                d.parent().addClass('active');
                c = d.parent().position().top + k;
                e.css('top', c);
                c + e.height() > j && e.css('bottom', 0);
                c + l > j && e.css('bottom', j - c - k).css('top', 'auto');
                e.appendTo(h);
                e.on('mouseleave.nav', function(a) {
                  $(i).remove();
                  e.appendTo(d.parent());
                  e.off('mouseleave.nav')
                    .css('top', 'auto')
                    .css('bottom', 'auto');
                  d.parent().removeClass('active');
                });
                $('.smart').length &&
                  $('<div class="dropdown-backdrop"/>')
                    .insertAfter('.app-aside')
                    .on('click', function(a) {
                      a && a.trigger('mouseleave.nav');
                    });
              }
            }
          });
          h.on('mouseleave', function(a) {
            e && e.trigger('mouseleave.nav');
            $('> .nav', h).remove();
          });
        },
      };
    },
  ]);
  angular.module('ec.angulr').directive('uiScrollTo', [
    '$location',
    '$anchorScroll',
    function(a, b) {
      return {
        restrict: 'AC',
        link: function(c, d, e) {
          d.on('click', function() {
            a.hash(e.uiScrollTo);
            b();
          });
        },
      };
    },
  ]);
  !(function() {
    angular.module('ec.angulr').directive('uiToggleClass', [
      '$timeout',
      '$document',
      function(a, b) {
        return {
          restrict: 'AC',
          link: function(a, b, c) {
            b.on('click', function(a) {
              function d(a, b) {
                for (
                  var c = new RegExp(
                      '\\s' +
                        a
                          .replace(/\*/g, '[A-Za-z0-9-_]+')
                          .split(' ')
                          .join('\\s|\\s') +
                        '\\s',
                      'g',
                    ),
                    d = ' ' + $(b)[0].className + ' ';
                  c.test(d);

                )
                  d = d.replace(c, ' ');
                $(b)[0].className = $.trim(d);
              }
              a.preventDefault();
              var e = c.uiToggleClass.split(','),
                f = (c.target && c.target.split(',')) || Array(b),
                g = 0;
              angular.forEach(e, function(a) {
                var b = f[f.length && g];
                -1 !== a.indexOf('*') && d(a, b);
                $(b).toggleClass(a);
                g++;
              });
              $(b).toggleClass('active');
            });
          },
        };
      },
    ]);
  })();
  angular.module('ui.load', []).service('uiLoad', [
    '$document',
    '$q',
    '$timeout',
    function(a, b, c) {
      var d = [],
        e = !1,
        f = b.defer();
      this.load = function(a) {
        a = angular.isArray(a) ? a : a.split(/\s+/);
        var b = this;
        e || (e = f.promise);
        angular.forEach(a, function(a) {
          e = e.then(function() {
            return a.indexOf('.css') >= 0 ? b.loadCSS(a) : b.loadScript(a);
          });
        });
        f.resolve();
        return e;
      };
      this.loadScript = function(e) {
        if (d[e]) return d[e].promise;
        var f = b.defer(),
          g = a[0].createElement('script');
        g.src = e;
        g.onload = function(a) {
          c(function() {
            f.resolve(a);
          });
        };
        g.onerror = function(a) {
          c(function() {
            f.reject(a);
          });
        };
        a[0].body.appendChild(g);
        d[e] = f;
        return f.promise;
      };
      this.loadCSS = function(e) {
        if (d[e]) return d[e].promise;
        var f = b.defer(),
          g = a[0].createElement('link');
        g.rel = 'stylesheet';
        g.type = 'text/css';
        g.href = e;
        g.onload = function(a) {
          c(function() {
            f.resolve(a);
          });
        };
        g.onerror = function(a) {
          c(function() {
            f.reject(a);
          });
        };
        a[0].head.appendChild(g);
        d[e] = f;
        return f.promise;
      };
    },
  ]);
})(window, void 0);



// WEBPACK FOOTER //
// ./src/app/vendor/ec-fe-bo-template/dist/angulr/angulr.js